var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageConnection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(-1153.875 -549.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    transform: "translate(1153.875 549.26)",
    fill: "#36f",
    stroke: "#e6e6e6",
    strokeWidth: 1,
    opacity: 0.179
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 26.5,
    ry: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 26,
    ry: 25.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rebase_edit_FILL0_wght400_GRAD0_opsz48",
    d: "M90.5,150.3l-1.259-1.259,2.489-2.489H87.077a3.522,3.522,0,0,1-2.579,2.579v9.836a3.539,3.539,0,0,1,1.934,1.259,3.6,3.6,0,1,1-5.668,0,3.539,3.539,0,0,1,1.934-1.259v-9.836a3.539,3.539,0,0,1-1.934-1.259,3.6,3.6,0,0,1,5.053-5.053,3.539,3.539,0,0,1,1.259,1.934h4.648l-2.489-2.489L90.5,141l4.678,4.648Zm9.9-8.247a3.584,3.584,0,1,1-2.549,1.05A3.47,3.47,0,0,1,100.392,142.05ZM83.6,164.24a1.767,1.767,0,1,0-1.282-.517A1.741,1.741,0,0,0,83.6,164.24Zm0-16.793a1.767,1.767,0,1,0-1.282-.517A1.741,1.741,0,0,0,83.6,147.447Zm16.793,0a1.767,1.767,0,1,0-1.282-.517A1.741,1.741,0,0,0,100.392,147.447ZM83.6,162.441ZM83.6,145.648ZM100.392,145.648Zm-3.928,8.427,1.289,1.259L91.4,161.661v2.579h2.549l6.387-6.387,1.259,1.259-6.9,6.927H89.6v-5.1Zm5.128,5.038-5.128-5.038,1.949-1.949a1.81,1.81,0,0,1,2.549.03l2.519,2.549a1.793,1.793,0,0,1,.51,1.274,1.651,1.651,0,0,1-.54,1.245Z",
    transform: "translate(1088.23 422.639)",
    fill: "#36f",
    opacity: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageConnection);
export default __webpack_public_path__ + "static/media/manage-connection.56b1417c6b706e20d97a6673ab3a8285.svg";
export { ForwardRef as ReactComponent };